/**
 * Seuil sous lequel la boutique affiche « Plus que X ».
 */
export const LOW_STOCK_THRESHOLD = 5;
/**
 * État du stock d'un produit en boutique pour une quantité choisie. Un
 * produit non suivi (ou un compte sans module d'inventaire) est illimité.
 *
 * `unitsFor` donne les unités qui sortent du stock pour une quantité
 * achetée, bonifications comprises (3 achetés + 1 offert = 4).
 */
export function stockState(item, quantity = 1, unitsFor = (value) => value) {
    const tracked = item.trackInventory === true && typeof item.availableQuantity === 'number';
    if (!tracked) {
        return {
            tracked: false,
            available: null,
            maxQuantity: Infinity,
            soldOut: false,
            preorder: false,
            low: false
        };
    }
    const available = Math.max(0, item.availableQuantity);
    const blocking = item.outOfStockPolicy !== 'BACKORDER';
    const maxQuantity = blocking
        ? maxPurchasableQuantity(available, unitsFor)
        : Infinity;
    return {
        tracked,
        available,
        maxQuantity,
        soldOut: blocking && maxQuantity < 1,
        preorder: !blocking && unitsFor(quantity) > available,
        low: available > 0 && available <= LOW_STOCK_THRESHOLD
    };
}
/**
 * Plus grande quantité achetable dont les unités (offertes comprises)
 * tiennent dans le stock disponible.
 */
function maxPurchasableQuantity(available, unitsFor) {
    for (let quantity = available; quantity > 0; quantity--) {
        if (unitsFor(quantity) <= available) {
            return quantity;
        }
    }
    return 0;
}
/**
 * Libellé de stock à afficher sur une carte produit, ou null.
 */
export function stockLabel(state) {
    if (state.soldOut) {
        return t('Out of stock');
    }
    if (state.preorder) {
        return t('Pre-order');
    }
    if (state.low && state.available != null) {
        return t('Only {{count}} left').replace('{{count}}', String(state.available));
    }
    return null;
}
/**
 * Quantités encore disponibles renvoyées par le serveur quand un produit
 * bloquant manque de stock (erreur OUT_OF_STOCK), par identifiant de produit.
 */
export function outOfStockFields(error) {
    var _a, _b;
    const graphQLErrors = error === null || error === void 0 ? void 0 : error.graphQLErrors;
    const stockError = graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.find((entry) => (entry === null || entry === void 0 ? void 0 : entry.message) === 'OUT_OF_STOCK');
    const fields = (_b = (_a = stockError === null || stockError === void 0 ? void 0 : stockError.extensions) === null || _a === void 0 ? void 0 : _a.fields) !== null && _b !== void 0 ? _b : ((error === null || error === void 0 ? void 0 : error.error) ===
        'OUT_OF_STOCK'
        ? error.fields
        : null);
    if (!fields) {
        return null;
    }
    return Object.fromEntries(Object.entries(fields).map(([key, value]) => [
        key.split(':')[0],
        Number(value) || 0
    ]));
}
